
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/labs/[...slug]",
      function () {
        return require("private-next-pages/labs/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/labs/[...slug]"])
      });
    }
  